var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-step-item',{attrs:{"label":_vm.$t('objective.objectives'),"value":"objectives"}},[_c('ObjectivesList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }